import swal from "sweetalert";

$(function($) {
    $('.openModalCourse').click(function () {
        $('#modalCourse'+this.id).modal('open');
    });
    $('.buyCourse').click(function () {

        if(!$("#terms"+this.id).is(':checked')){
            swal({
                text: "Debes aceptar los terminos y condiciones",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        if($('#typeCourse'+this.id).val() == '2'){
            if($('#nameCourse'+this.id).val() == '' || $('#emailCourse'+this.id).val() == '' || $('#phoneCourse'+this.id).val() == ''){
                swal({
                    text: "Debes completar los campos de nombre,correo electronico y celular",
                    icon: imageURL,
                    button: "OK!",
                });
                return false;
            }
        }

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });
        $.ajax({
            url: https + "buyCourse",
            method: "POST",
            data: {
                id: this.id,
                type: $('#typeCourse'+this.id).val(),
                name: $('#nameCourse'+this.id).val(),
                mail: $('#emailCourse'+this.id).val(),
                phone: $('#phoneCourse'+this.id).val(),
                action: "buyCourse"
            },
            success: function (data) {
                if ($.trim(data) == "complet") {
                    location.href = https + "payuCourse";
                } else if ($.trim(data) == "free") {
                    swal({
                        title: "Curso adquirido",
                        text: "presione cualquier boton para recargar la pagina y poder visualizarlo",
                        icon: "success",
                        buttons: true,
                        dangerMode: true,
                    })
                        .then((willDelete) => {
                            if (willDelete) {
                                location.reload();
                            } else {
                                location.reload();
                            }
                        });
                } else {
                    swal({
                        text: "Ha ocurrido un error" + data,
                        icon: imageURL,
                        button: "OK!",
                    });
                }
            }
        });
    });
});
